import React, { useEffect, useState } from "react";
import { Drawer, Layout } from "antd";
import { Link, Outlet } from "react-router-dom";
import SettingsSideMenu from "../components/layout/SettingsSideMenu";
import Theme from "../theme/Theme";
import MainHeader from "../components/layout/MainHeader";

const { Sider } = Layout;

function SettingsLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const proWidth = document.body.clientWidth;

  useEffect(() => {
    /*In tab view collapse menu when loaded*/
    if (proWidth < 720) {
      setCollapsed(true);
    }
  }, []);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/*Main side menu*/}
      <Sider
        collapsible
        collapsed={collapsed}
        trigger={null}
        breakpoint="lg"
        style={{
          height: "100vh",
          overflow: "hidden",
          backgroundColor: Theme().sideMenu,
          borderRight: `2px solid ${Theme().navBorder}`,
        }}
        className="transparent-scroll hidden sm:block"
      >
        <Link to="/top-plans">
          <div 
            className="logo flex items-center justify-center" 
            style={{ 
              gap: '12px',
              padding: '16px 16px 12px 16px',
            }}
          >
            <img 
              src={require('../assets/images/logo.png')} 
              alt="Strategizer" 
              style={{ 
                width: collapsed ? '32px' : '40px',
                height: collapsed ? '32px' : '40px',
                transition: 'all 0.3s'
              }} 
            />
            {!collapsed && (
              <span 
                style={{ 
                  fontSize: '20px',
                  fontWeight: 600,
                  color: Theme().textPrimary,
                  fontFamily: 'Inter, sans-serif',
                }}
              >
                Strategizer
              </span>
            )}
          </div>
        </Link>
        <SettingsSideMenu collapsed={collapsed} />
      </Sider>
      {/*Mobile side menu*/}
      <Drawer
        width="280"
        closable={false}
        placement="left"
        onClose={() => setCollapsed(true)}
        visible={!collapsed}
        className="sm:hidden"
        style={{ padding: 0 }}
        bodyStyle={{ backgroundColor: Theme().sideMenu, padding: 0 }}
      >
        <div 
          className="logo flex items-center justify-center" 
          style={{ 
            gap: '12px',
            padding: '20px 16px',
          }}
        >
          <img 
            src={require('../assets/images/logo.png')} 
            alt="Strategizer" 
            style={{ 
              width: '40px',
              height: '40px'
            }} 
          />
          <span 
            style={{ 
              fontSize: '20px',
              fontWeight: 600,
              color: Theme().textPrimary,
              fontFamily: 'Inter, sans-serif',
            }}
          >
            Strategizer
          </span>
        </div>
        <SettingsSideMenu collapsed={collapsed} />
      </Drawer>
      <Layout className="site-layout" style={{ overflow: 'auto', backgroundColor: Theme().background }}>
        <MainHeader
          openMenu={() => setCollapsed(!collapsed)}
          menu={collapsed}
        />
        <div style={{ overflow: 'auto', height: 'calc(100vh - 64px)', backgroundColor: Theme().background }}>
          <Outlet />
        </div>
      </Layout>
    </Layout>
  );
}

export default SettingsLayout;
